
import { Module } from '../core';

import setDatawinFetchAttributes from './commands/setDatawinFetchAttributes';
import setDatawinObjectList from './commands/setDatawinObjectList';

export default class ModuleData extends Module {

    constructor() {
        super('data');
    }

    initCommands() {
        this.addCommand(setDatawinFetchAttributes);
        this.addCommand(setDatawinObjectList);
    }
}
